<div class="d-flex date-selection">
  <ngb-datepicker
    #datePicker
    class="col-12"
    [displayMonths]="2"
    [dayTemplate]="dayTemplate"
    [startDate]="dateConversionService.toNgbDate(startDate)"
    [minDate]="dateConversionService.toNgbDate(minDate)"
    [maxDate]="dateConversionService.toNgbDate(maxDate)"
    [firstDayOfWeek]="dateConversionService.getFirstDayOfWeek()"
    (dateSelect)="dateSelectionService.handleDateSelection($event)"
    navigation="none"
    outsideDays="hidden"
  />
</div>

<ng-template #dayTemplate let-date let-focused="focused">
  <span
    class="cell"
    [class.focused]="focused"
    [class.range]="dateSelectionService.isRange$(date) | async"
    [class.faded]="(dateSelectionService.isHovered$(date, hoveredDate) | async) || (dateSelectionService.isInside$(date) | async)"
    [attr.data-qa]="dateTestId(testIdPrefix, date)"
    (mouseover)="hoveredDate=date" 
    (mouseout)="hoveredDate=null"
  >
    {{ date.day }}
  </span>
</ng-template>